<template>
  <b-container fluid>
    <bulk-import />
  </b-container>
</template>
<script>
  import BulkImport from '@/components/BulkImport'

  export default {
    name: 'BulkImportPage',
    components: {
      BulkImport
    }
  }
</script>
